import styled from 'styled-components';
import { Card, Container, Row, Image, Spinner } from 'react-bootstrap';
import { CustomButton, CustomFormik, CustomInput } from 'components/CustomForm';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import InstituteLogo from 'assets/images/institute-logo.png';
import { useMutation } from 'react-query';
import { changePassword } from 'network/apis/LoginApi';
import { toast } from 'react-toastify';
import { useContext, useState } from 'react';
import { GlobalContext } from 'context/GlobalContext';
import { getErrorMessage } from "helpers/strings";
import { device } from 'helpers/screen';
import { useLocation, useNavigate } from 'react-router-dom';
import { ADMIN_USER, COMPANY_USER, PROVINCE_USER } from 'context/GlobalContext';
import CommonLogin from 'components/CommonLogin';
import { MdClose } from "react-icons/md";

const CloseButton = styled.div`
	background-color: #424250;
	width: 2rem;
	height: 2rem;
	border-radius: 8px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	position: absolute;
	top: 12px;
	right: 10px;
    cursor: pointer;
`;

const ChangePasswordPage = () => {
    const { logout } = useContext(GlobalContext);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const { state: { from } } = useLocation();

    const changePasswordMutation = useMutation(changePassword, {
        onSuccess: (data) => {
            toast('رمز ورود با موفقیت تغییر یافت، لطفا مجددا وارد شوید', { type: 'success', position: 'bottom-right' });

            setTimeout(() => {
                logout();
                navigate('/login');
            }, 888);
        },
        onError: (err) => {
            toast(
                getErrorMessage(err),
                { type: 'error', position: 'bottom-right' }
            );
        },
        onSettled: () => {
            setLoading(false);
        },
    });

    const header = () => (
        <div className='w-100 mb-3'>
            <h3 className='text-center'>تغییر رمز ورود</h3>
            <CloseButton onClick={() => navigate(from || '/')}>
                <MdClose color="#fff" />
            </CloseButton>
        </div>
    );

    return (
        <CommonLogin header={header()}>
            <Formik
                initialValues={{ current_password: '', new_password: '', confirm_password: '' }}
                validate={(values) => {
                    const errors = {};
                    if (!values.current_password) {
                        errors.current_password = 'ضروری';
                    } else if (!values.new_password) {
                        errors.new_password = 'پسورد معتبر نمی باشد';
                    } else if (!values.confirm_password) {
                        errors.confirm_password = 'پسورد ها مطابقت ندارند';
                    }
                    return errors;
                }}
                onSubmit={(values, { resetForm }) => {
                    setLoading(true);
                    changePasswordMutation.mutate(values);
                    resetForm();
                }}
            >
                {({ isSubmitting }) => (
                    <CustomFormik>
                        <Field type="password" name="current_password">
                            {({
                                field,
                                meta: { touched, error }
                            }) => <CustomInput className={touched && error ? "invalid" : ""} {...field} placeholder='رمز عبور کنونی' />
                            }
                        </Field>
                        <ErrorMessage name="current_password" component="div" />
                        <Field type="password" name="new_password">
                            {({
                                field,
                                meta: { touched, error }
                            }) => <CustomInput className={touched && error ? "invalid" : ""} {...field} placeholder='رمز عبور جدید' />
                            }
                        </Field>
                        <ErrorMessage name="new_password" component="div" />
                        <Field type="password" name="confirm_password">
                            {({
                                field,
                                meta: { touched, error }
                            }) => <CustomInput className={touched && error ? "invalid" : ""} {...field} placeholder='تکرار رمز جدید' />
                            }
                        </Field>
                        <ErrorMessage name="confirm_password" component="div" />
                        <button
                            type="submit"
                            disabled={isSubmitting || loading}
                            className='d-flex align-items-center justify-content-center mt-2 mb-4'
                        >
                            {loading ? (
                                <Spinner animation="border" role="status" size='sm' />
                            ) : (
                                <span>ارسال</span>
                            )}
                        </button>
                    </CustomFormik>
                )}
            </Formik>
        </CommonLogin>
    );
};

export default ChangePasswordPage;
